import { render, staticRenderFns } from "./detail-assurance.vue?vue&type=template&id=484ee952&scoped=true"
import script from "./detail-assurance.vue?vue&type=script&lang=js"
export * from "./detail-assurance.vue?vue&type=script&lang=js"
import style0 from "./detail-assurance.vue?vue&type=style&index=0&id=484ee952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ee952",
  null
  
)

export default component.exports